import { ReactElement } from 'react';
import { Icon, TIconProps } from '@/common/components/Icons/Icon';
import { IMenhirBenefitSlug } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { TOrderCategorySlug } from '@/common/integrations/menhir/employee/orders/orders.types';

interface IProps {
  benefit: IMenhirBenefitSlug | Extract<TOrderCategorySlug, 'health'>;
  color?: string;
}

export const BenefitIcon = ({ benefit, color }: IProps) => {
  const icon = benefitIconMapper[benefit] ?? <Icon icon="seedling" />;
  return <icon.type {...icon.props} color={color ?? 'accentSecondary10'} />;
};

export const benefitIconMapper: Record<
  IMenhirBenefitSlug | Extract<TOrderCategorySlug, 'health' | 'meals'>,
  ReactElement<TIconProps>
> = {
  'childcare-voucher': <Icon icon="ticket-simple" />,
  'health-wellbeing': <Icon icon="spa" />,
  'gym-fitness': <Icon icon="heart-pulse" />,
  'education-training': <Icon icon="book-open" />,
  'senior-expenses': <Icon icon="person-cane" />,
  technology: <Icon icon="desktop" />,
  'professional-training': <Icon icon="graduation-cap" />,
  transportation: <Icon icon="bus" />,
  'retirement-investment': <Icon icon="piggy-bank" />,
  parking: <Icon icon="parking" />,
  'summer-camp': <Icon icon="sun" />,
  donation: <Icon icon="hand-holding-heart" />,
  'other-benefits': <Icon icon="shapes" />,
  health: <Icon icon="shield-plus" />,
  cashout: <Icon icon="money-bill-transfer" />,
  fringe: <Icon icon="icons" />,
  recreation: <Icon icon="sun" />,
  'family-care-services': <Icon icon="family-pants" />,
  'it-transportation': <Icon icon="bus" />,
  'it-education': <Icon icon="book-open" />,
  'pension-funds': <Icon icon="piggy-bank" />,
  meals: <Icon icon="utensils" />,
  'es-public-transport': <Icon icon="bus" />,
  'es-childcare': <Icon icon="baby-carriage" />,
  'es-professional-development': <Icon icon="graduation-cap" />,
};
